import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import {
  createUserGroup,
  createUserRolesForAGroup,
} from 'api/userGroups.service';
import { userGroupsKeys } from './queryKeys';

export const useUserGroupCreateQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: async (info: { name: string; rolesList: Array<string> }) => {
      setLoading();
      const group = await createUserGroup(info.name);

      return createUserRolesForAGroup(group.id, info.rolesList);
    },
    onSuccess: () => {
      toast.success('Group has been created successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({ queryKey: userGroupsKeys.all });
    },
  });

  return { isLoading: isPending, mutate, data };
};
